'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext } from 'react';
import { Text } from '../Text';
import { PriceContext } from './PriceContext';
export const Cost = ({
  children,
  ...rest
}) => {
  const {
    size
  } = useContext(PriceContext);
  const fontSizes = {
    sm: 2,
    md: 4,
    lg: 5
  };
  return /*#__PURE__*/React.createElement(Text, _extends({
    size: fontSizes[size],
    color: "var(--aui-on-surface)"
  }, rest), children);
};